// extracted by mini-css-extract-plugin
export default {"buttonMore":"ItemComponent_buttonMore__xwj7o","item":"ItemComponent_item__O3f4g"};